module.exports = "/wp-content/plugins/farmacy/assets/js/images/profile-close-icon-2b5ab2c18e0d738da784cfdaf8a9c070.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/common/header-control-bar/profile-button/img/profile-close-icon.png
 ** module id = 567
 ** module chunks = 1 27 28 141
 **/